import React, { useContext, useState } from "react"
import { DimensionsContext, IS_WEB } from "@common/utils/mobileUtils"
import { ModalM } from "@common/components/modal/ModalM"
import TitleM from "@common/components/text/TitleM"
import { theme } from "@common/theme/theme"
import { useController, useForm } from "react-hook-form"
import TextInputM from "../../../common/components/input/TextInputM"
import { yupResolver } from "@hookform/resolvers/yup"
import yup from "../../../data/utility/validation"
import FilledButtonM from "../../../common/components/button/FilledButtonM"
import { backOfficeService } from "../../../data/services/backOfficeService"
import { useApiStatus } from "../../../common/hooks/useApiStatus"
import { ListItemM } from "../../../common/components/list/ListItemM"
import { ListGroupM } from "../../../common/components/list/ListGroupM"
import { View } from "react-native"
import { studentsService } from "../../../data/services/studentsService"
import { DialogM } from "@common/components/alert/dialog/Dialog"
import { PAYMENT_COLLECTION_DAYS } from "@data/constants/studentsConstants"

const formSchema = yup.object().shape({
    transfer_amount: yup.number().required(),
    tutoring_credit_amount: yup.number().required(),
    application_fee_amount: yup.number().required(),
    application_compensation_amount: yup.number().required(),
})

export default function ChangePaymentCollectionDayModal(props) {
    const {
        isOpen,
        handleShowModal,
        data,
        onUpdatePaymentCollectionDay,
        isLoading,
        apiRequest,
    } = props
    const dimensions = useContext(DimensionsContext)
    const resolver = yupResolver(formSchema)

    const [payment_collection_day, setpayment_collection_day] = useState(
        data.payment_collection_day
    )

    const items = PAYMENT_COLLECTION_DAYS.map((value) => ({
        value,
        description: `Le ${value} du mois`,
    }))

    const {
        control,
        handleSubmit,
        formState: { errors, dirtyFields },
    } = useForm({
        resolver,
        defaultValues: {
            payment_collection_day: payment_collection_day,
        },
    })

    const { field } = useController({
        control,
        name: "payment_collection_day",
    })

    const onSubmit = (payment_collection_day) => {
        onUpdatePaymentCollectionDay(
            payment_collection_day.payment_collection_day
        )
        props.apiRequest(
            studentsService.studentChangePaymentCollectionDay,
            {},
            {
                day: payment_collection_day.payment_collection_day,
                email: data?.email,
            }
        )
    }

    useApiStatus(
        studentsService.studentChangePaymentCollectionDay, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        (successData) => {
            setpayment_collection_day(successData.payment_collection_day)
            const studentName = successData?.firstname?.trim() || ""
            const day = successData?.payment_collection_day
            DialogM.show({
                text1: "Opération réussie",
                text2: studentName
                    ? `Le prélèvement mensuel de ${studentName} est désormais fixé au ${day} du mois.`
                    : `Votre prélèvement mensuel est désormais fixé au ${day} du mois.`,
                onPress: () => {},
            })
        } // success callback
    )
    //   useApiStatus(
    //     backOfficeService.editBilling, // api service
    //     null, // success message on toast (string or null)
    //     true, // error message from server in toast (true) or keep it in redux state (false)
    //     (successData) => {
    //     }
    //   );
    return (
        <ModalM
            visible={isOpen}
            onDismiss={handleShowModal}
            style={{
                // width: dimensions.width > 800 ? "50%" : "90%",
                maxHeight: "80%",
                padding: 20,
                alignItems: "center",
            }}
        >
            <TitleM>Ma date de prélèvement</TitleM>
            <View
                style={{
                    marginBottom: 10,
                    marginTop: 20,
                    width: "100%",
                    flexDirection: "row",
                    justifyContent: "space-between",
                }}
            >
                <ListGroupM
                    options={items}
                    style={{
                        // marginHorizontal: 20
                        marginBottom: 70,
                    }}
                    itemHeight={70}
                    renderItem={(item) => {
                        return (
                            <ListItemM
                                isFirst={item.index === 0}
                                isLast={item.index === items?.length - 1}
                                onPress={() => {
                                    field.onChange(item.item?.value)
                                    const studentName =
                                        data?.firstname?.trim() || ""
                                    const text1 = studentName
                                        ? `Voulez-vous changer la date de prélèvement de l'abonnement de ${studentName} ?`
                                        : "Voulez-vous changer votre date de prélèvement ?"
                                    const text2 =
                                        "Nouvelle date : le " +
                                        item.item?.value +
                                        " du mois"
                                    DialogM.show({
                                        text1: text1,
                                        text2: text2,
                                        buttonText1: "Confirmer",
                                        buttonColor1: theme.colors.primary,
                                        onPress: () => {
                                            onSubmit({
                                                payment_collection_day:
                                                    item.item?.value,
                                            })
                                        },
                                        buttonText2: "Annuler",
                                        onPressBack: () => {},
                                    })
                                    handleShowModal()
                                }}
                                itemHeight={70}
                                selected={
                                    item.item?.value === payment_collection_day
                                }
                                option={item.item}
                            />
                        )
                    }}
                />
            </View>
        </ModalM>
    )
}
